// Traduz um erro de upload de anexo (axios) numa mensagem clara pro usuário.
// O backend devolve 400 `{error: file_too_large|unsupported_type|no_file}` e o
// axios sinaliza timeout via code ECONNABORTED. Antes a UI mostrava sempre um
// genérico "Não foi possível anexar X" — o que escondia o motivo real (o caso
// mais comum: PDF médio/escaneado que estoura o timeout de upload).

const MAX_UPLOAD_MB = 25;

interface AxiosLikeError {
  code?: string;
  message?: string;
  response?: { status?: number; data?: { error?: string } };
}

export function attachmentErrorMessage(fileName: string, err: unknown): string {
  const e = (err ?? {}) as AxiosLikeError;

  // Timeout do axios (ECONNABORTED) ou mensagem de timeout.
  if (e.code === 'ECONNABORTED' || /timeout/i.test(e.message ?? '')) {
    return `"${fileName}" é grande ou demorou demais para ser processado. Tente um PDF menor ou com menos páginas.`;
  }

  const code = e.response?.data?.error;
  if (code === 'file_too_large') {
    return `"${fileName}" excede o tamanho máximo de ${MAX_UPLOAD_MB} MB.`;
  }
  if (code === 'unsupported_type') {
    return `"${fileName}" tem um formato não suportado.`;
  }

  return `Não foi possível anexar "${fileName}".`;
}
